function Faq() {
  const faqs = [
    {
      question: "What is MicrofinanceBazar?",
      answer:
        "MicrofinanceBazar refers to digital Fintech intermediary providing financial services like loans, savings, and insurance to low-income individuals or groups who do not have access to traditional banking services. It helps people start or expand small businesses, improve their living standards, and break the cycle of poverty.",
    },
    {
      question: "How much money can I borrow?",
      answer:
        "The minimum loan amount is INR 5,000. The borrower's ability to repay the loan can range loan limit from ₹10,000 to ₹2,00,000, depending on the eligibility.",
    },
    {
      question: "Who is eligible for a MicrofinanceBazar loan?",
      answer: `Eligibility for microfinance loans typically includes:
    Income group: Low-income individuals/ females, Physically Disabled, Transgenders.
    Business/Income source: Small businesses, self-employed individuals, farmers, or those in the informal sector.
    Geography: Individuals living in rural or semi-urban areas, where access to traditional banking services may be limited.
    Credit history: MicrofinanceBazar assesses the creditworthiness of borrowers and co-borrowers, which can change depending on the scheme.`,
    },
    {
      question: "How can I repay my monthly loan repayments?",
      answer:
        "You can pay by monthly amortization installments, starting one month after the loan disbursement and payable via the borrower's designated loan-linked Deposit Account with MicrofinanceBazar.",
    },
    {
      question: "What types of Microfinance loans are available?",
      answer: `Common types of microfinance loans include:
    Income-generating loans: For businesses, agriculture, and self-employment.
    Emergency loans: Short-term loans for urgent needs like medical expenses.
    Housing loans: For building or improving homes in rural areas.
    Consumer loans: For purchasing basic goods and services, like household items or education and marriage in family.`,
    },
    {
      question:
        "How does the MicrofinanceBazar notify me about my instalments, loan rate, and other details?",
      answer:
        "MicrofinanceBazar sends you a monthly notification regarding your loan, remaining principal, remaining installments, the interest rate on outstanding amounts, etc.",
    },
    {
      question: "What are the interest rates for Microfinance loans in India?",
      answer:
        "Interest rates for microfinance loans generally range between 16% to 22% per annum. However, these rates may vary depending on the type of loan, the borrower’s profile, it’s essential to check the terms carefully.",
    },
    {
      question: "What is the repayment period for Microfinance loans?",
      answer:
        "Repayment periods can range from 6 months to 36 months, depending on the loan amount and type. MFIs may offer flexible repayment options, including weekly, monthly, or bi-monthly payments.",
    },
    {
      question: "What documents do I need to apply for a Microfinance loan?",
      answer: `Documents commonly required include:
    Proof of identity: Aadhar card, voter ID, passport, etc.
    Proof of address: Utility bills, rent agreement, etc.
    Income proof: Bank statements, income certificates, or proof of self-employment.
    Business-related documents (if applying for a Rural business loan), business plan, etc.
    Photographs: Passport-sized photos.`,
    },
    {
      question: "Are MicrofinanceBazar loans secured or unsecured?",
      answer:
        "Most microfinanceBazar loans are unsecured, meaning they don’t require collateral. The loans are typically based on the borrower’s group lending or social collateral, where the borrower’s family or community guarantees the loan.",
    },
    {
      question: "Can I take a loan from multiple Microfinance institutions?",
      answer:
        "Yes, you are allowed to borrow from several MFIs, but there are restrictions in place to avoid excessive debt. Borrower information is shared, and a credit bureau monitors loan histories. It's crucial to confirm your ability to repay loan, in accordance with MicrofinanceBazar's policy.",
    },
    {
      question: "What happens if I default on a Microfinance loan?",
      answer: `Defaulting on a MicrofinanceBazar loan will lead to:
    Penalties or additional charges.
    Damage to your credit rating, affecting your ability to borrow in the future.
    Legal action: If payments are not made consistently, MicrofinanceBazar may take legal action to recover the debt.
    Loss of social standing: If you are part of a group loan, your default may affect others.`,
    },
    {
      question: "How does a group loan work in MicrofinanceBazar?",
      answer:
        "In MicrofinanceBazar group lending, a group of borrowers (often from the same community) collectively guarantees each other's loans. This system encourages borrowers to ensure timely repayment as their peers' creditworthiness is tied to their own. Group loans are typically smaller and often used in rural areas for agricultural or micro-enterprise purposes.",
    },
    {
      question: "Can I use a MicrofinanceBazar loan for personal expenses?",
      answer:
        "MicrofinanceBazar loans are generally meant for income-generating activities like setting up or expanding a small business, agriculture, or other productive purposes. Using the loan for personal expenses may violate the loan terms, and you should always confirm the allowed usage with the MicrofinanceBazar.",
    },
    {
      question: "How is the loan disbursed?",
      answer:
        "Loans are typically disbursed in the following ways:\nDirect bank transfer to the borrower’s account.\nSome loans may be disbursed in instalments based on project milestones or business needs.",
    },
    {
      question: "How can I repay a Microfinance loan?",
      answer:
        "Repayment options can include:\nBank transfer at branch locations.\nMobile wallet or online payment options for digital platforms.\nPost offices or agents in rural areas, especially if access to banks is limited.",
    },
  ];

  return (
    <>
      <section class="py-8 bg-auto bg-image">
        <div class="container my-lg-8">
          <div class="row justify-content-center py-6">
            <div class="col-12">
              <div className="z-2 position-relative">
                <h1 class="mb-2 display-4 text-white fw-bold">
                  <span>Frequently Asked Questions</span>
                </h1>
                <ol class="breadcrumb">
                  <li class="breadcrumb-item lead">
                    <a href="#">Home</a>
                  </li>
                  <li
                    class="breadcrumb-item active lead text-white"
                    aria-current="page"
                  >
                    FAQs
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="pb-6">
        <div className="container mt-7 mb-2">
          <div className="row pt-2">
            <div className="col-12">
              <div className="row d-flex">
                <div className="col-lg-7 col-md-12 mb-3">
                  <span className="badge bg-dark-soft rounded-pill fs-5 px-4 mb-2">
                    <span className="fw-bold">FAQs</span> - Microfinance Bazar
                  </span>
                  <h1 class="fw-bold mb-0">
                    Do you want more{" "}
                    <u class="text-primary">
                      <span class="text-dark">information?</span>
                    </u>
                  </h1>
                  <p className="lead lh-sm mt-2">
                    Dive into our FAQs to find detailed insights, helpful tips,
                    and everything you need to know about Microfinance Bazar.
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-12 d-flex align-items-center">
              <div
                className="accordion accordion-flush w-100 pe-lg-5 pe-0 me-lg-5 me-0"
                id="accordionFlushExample"
              >
                {faqs.map((faq, index) => {
                  const collapseId = `flush-collapse-${index}`;
                  const headingId = `flush-heading-${index}`;
                  const isFirst = index === 0;

                  return (
                    <div className="accordion-item" key={index}>
                      <h2 className="accordion-header" id={headingId}>
                        <button
                          className={`accordion-button px-0 bg-white ${
                            isFirst ? "" : "collapsed"
                          }`}
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target={`#${collapseId}`}
                          aria-expanded={isFirst ? "true" : "false"}
                          aria-controls={collapseId}
                        >
                          <h3 className="faqs-text text-dark fw-medium m-0">
                            {faq.question}
                          </h3>
                        </button>
                      </h2>
                      <div
                        id={collapseId}
                        className={`accordion-collapse collapse ${
                          isFirst ? "show" : ""
                        }`}
                        aria-labelledby={headingId}
                        data-bs-parent="#accordionFlushExample"
                      >
                        <div className="accordion-body px-0">
                          <p
                            className="fs-4 fw-light mb-4 text-secondary lh-sm"
                            style={{ whiteSpace: "pre-line" }}
                          >
                            {faq.answer}
                          </p>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Faq;
